<template>
  <div class="w-full flex flex-col items-center mt-4 gap-4">
    <div class="grid grid-rows-2 grid-cols-3 gap-1">
      <button
        class="col-span-1 col-start-2 p-6 text-center border border-gray-500 bg-white shadow-sm"
        @click="moveBox('top')"
      >
        ↑
      </button>
      <button
        class="row-start-2 col-span-1 p-6 text-center border border-gray-500 bg-white shadow-sm"
        @click="moveBox('left')"
      >
        ←
      </button>
      <button
        class="row-start-2 col-span-1 p-6 text-center border border-gray-500 bg-white shadow-sm"
        @click="moveBox('bottom')"
      >
        ↓
      </button>
      <button
        class="row-start-2 col-span-1 p-6 text-center border border-gray-500 bg-white shadow-sm"
        @click="moveBox('right')"
      >
        →
      </button>
    </div>
    <div class="grid grid-cols-2 gap-1">
      <button
        class="p-6 text-center border border-gray-500 bg-white shadow-sm text-xl font-bold"
        @click="resizeBox('shrink')"
      >
        −
      </button>
      <button
        class="p-6 text-center border border-gray-500 bg-white shadow-sm text-xl font-bold"
        @click="resizeBox('grow')"
      >
        +
      </button>
    </div>
  </div>
</template>

<script>
import { clampBox } from "@/utils/blur";
import { mapGetters } from "vuex";

export default {
  name: "BlurControls",
  props: {
    box: { type: Object, required: true },
    imageDimensions: { type: Object, default: null },
    isSimpleMode: { type: Boolean, default: false },
    originalBox: { type: Object, default: null }
  },
  emits: ["update"],
  data() {
    return {
      moveStep: 1
    };
  },
  computed: {
    ...mapGetters({
      getBlurMaxBoxWidth: "bodyprint/getBlurMaxBoxWidth",
      getBlurMaxBoxHeight: "bodyprint/getBlurMaxBoxHeight",
      getBlurPositionRatio: "bodyprint/getBlurPositionRatio",
      getBlurSimpleResizeMargin: "bodyprint/getBlurSimpleResizeMargin"
    })
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
  },
  methods: {
    moveBox(direction) {
      let newBox = { ...this.box };
      switch (direction) {
        case "top":
          newBox.y -= this.moveStep;
          break;
        case "bottom":
          newBox.y += this.moveStep;
          break;
        case "left":
          newBox.x -= this.moveStep;
          break;
        case "right":
          newBox.x += this.moveStep;
          break;
      }
      this.$emit("update", this.doClamp(newBox));
    },
    resizeBox(action) {
      const delta = action === "grow" ? this.moveStep : -this.moveStep;
      const newBox = {
        x: this.box.x - delta,
        y: this.box.y - delta,
        width: this.box.width + delta * 2,
        height: this.box.height + delta * 2
      };
      this.$emit("update", this.doClamp(newBox));
    },
    doClamp(box) {
      return clampBox(box, {
        imageDimensions: this.imageDimensions,
        isSimpleMode: this.isSimpleMode,
        originalBox: this.originalBox,
        simpleResizeMargin: this.getBlurSimpleResizeMargin,
        maxBoxWidth: this.getBlurMaxBoxWidth,
        maxBoxHeight: this.getBlurMaxBoxHeight,
        maxPositionRatio: this.getBlurPositionRatio
      });
    },
    onKeyDown(e) {
      const arrowMap = {
        ArrowUp: "top",
        ArrowDown: "bottom",
        ArrowLeft: "left",
        ArrowRight: "right"
      };
      if (arrowMap[e.code]) {
        e.preventDefault();
        this.moveBox(arrowMap[e.code]);
        return;
      }
      if (e.key === "-") {
        e.preventDefault();
        this.resizeBox("shrink");
      } else if (e.key === "+" || e.key === "=") {
        e.preventDefault();
        this.resizeBox("grow");
      }
    }
  }
};
</script>
